import firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyDZkWN_5zUy4lfc4YbTVg_M00ic8qOXVW4",
  authDomain: "oruss-officiall.firebaseapp.com",
  projectId: "oruss-officiall",
  storageBucket: "oruss-officiall.appspot.com",
  messagingSenderId: "749122252658",
  appId: "1:749122252658:web:b4be7c425e2f57dec877eb",
  measurementId: "G-DV8H2W4SR8"
};

// sepatu-cod
// const firebaseConfig = {
//   apiKey: "AIzaSyBS798XWx2kxx433P1aZXwG38KahvKuEHY",
//   authDomain: "sepatu-cod.firebaseapp.com",
//   databaseURL: "https://sepatu-cod.firebaseio.com",
//   projectId: "sepatu-cod",
//   storageBucket: "sepatu-cod.appspot.com",
//   messagingSenderId: "566388621868",
//   appId: "1:566388621868:web:c474c643715b26a4f7c789",
//   measurementId: "G-ETRN0RE2YD"
// };
firebase.initializeApp(firebaseConfig);
export default firebase;